;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="97c1680e-f619-4975-83f7-f73e188984a9",e._sentryDebugIdIdentifier="sentry-dbid-97c1680e-f619-4975-83f7-f73e188984a9")}catch(e){}}();
{
  var _sentryModuleMetadataGlobal =
    typeof window !== "undefined"
      ? window
      : typeof global !== "undefined"
      ? global
      : typeof self !== "undefined"
      ? self
      : {};

  _sentryModuleMetadataGlobal._sentryModuleMetadata =
    _sentryModuleMetadataGlobal._sentryModuleMetadata || {};

  _sentryModuleMetadataGlobal._sentryModuleMetadata[new _sentryModuleMetadataGlobal.Error().stack] =
    Object.assign(
      {},
      _sentryModuleMetadataGlobal._sentryModuleMetadata[new _sentryModuleMetadataGlobal.Error().stack],
      {"_sentryBundlerPluginAppKey:petsdeli-sentry":true}
    );
}
"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7817],{

/***/ 29244:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ getSmartCollection; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34727);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97582);
/* harmony import */ var _sentry_browser__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(39424);
/* harmony import */ var api_product__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94070);
/* harmony import */ var constants_feature_flag__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93841);
/* harmony import */ var utils_axios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21744);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99108);








var featureFlg = (0,constants_feature_flag__WEBPACK_IMPORTED_MODULE_1__/* .getFeatureFlag */ .O)(constants_feature_flag__WEBPACK_IMPORTED_MODULE_1__/* .FeatureFlag.smartCollectionEndpoint */ .T.smartCollectionEndpoint);
function getSmartCollection(input, shouldOmitError) {
    return _getSmartCollection.apply(this, arguments);
}
function _getSmartCollection() {
    _getSmartCollection = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(input, shouldOmitError) {
        var audiences, result, _tmp, _tmp1, _tmp2, _tmp3;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!!featureFlg) return [
                        3,
                        5
                    ];
                    if (!(typeof input === "string")) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        (0,api_product__WEBPACK_IMPORTED_MODULE_0__/* .fetchCollectionWithSegmentation */ .ae)(input, shouldOmitError)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
                case 2:
                    if (!("slug" in input && input.slug)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        (0,api_product__WEBPACK_IMPORTED_MODULE_0__/* .fetchCollectionWithSegmentation */ .ae)(input.slug, shouldOmitError)
                    ];
                case 3:
                    return [
                        2,
                        _state.sent()
                    ];
                case 4:
                    throw new Error("unexpected input");
                case 5:
                    _tmp = {};
                    _tmp1 = {};
                    _tmp2 = {};
                    return [
                        4,
                        utils_axios__WEBPACK_IMPORTED_MODULE_2__/* .axios.post */ .od.post("https://merchant.petsdeli.de/api/legacy/smart-collections", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_tmp, typeof input === "string" ? (_tmp1.slug = input, _tmp1) : input), (_tmp2.isPdexApi = true, _tmp2)).then(function(data) {
                            audiences = data.config.headers && data.config.headers["audiences"];
                            return data;
                        }).then(function(param) {
                            var data = param.data;
                            return data;
                        })
                    ];
                case 6:
                    result = _state.sent();
                    if (!result) {
                        throw new Error("unexpected results");
                    }
                    _tmp3 = {};
                    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .isSmartCollectionResponse */ .A)(result) && result.items.length === 0) {
                        (0,_sentry_browser__WEBPACK_IMPORTED_MODULE_7__/* .captureMessage */ .uT)("No items are found via SmartCollection API", (_tmp3.level = "debug", _tmp3.extra = {
                            input: input,
                            audiences: audiences
                        }, _tmp3));
                    }
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return _getSmartCollection.apply(this, arguments);
}


/***/ }),

/***/ 50490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);


/**
 * Badge component
 */ var Badge = function(param) {
    var children = param.children, className = param.className, rounded = param.rounded, type = param.type;
    var colorClassName = "";
    switch(type){
        case "Red-Sale":
        case "Discount":
            colorClassName = "bg-badge-discount font-medium text-text-dark-bg-contrast-white";
            break;
        case "Bestseller":
            colorClassName = "bg-badge-bestseller text-primary-main";
            break;
        case "General":
        case "Generic-Beige":
            colorClassName = "bg-badge-generic text-text-primary";
            break;
        default:
            colorClassName = "bg-badge-new text-primary-main";
            break;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("h-auto shrink-0 items-center justify-center px-1.5 py-0.5 text-center text-sm ", colorClassName, rounded ? "rounded-full" : "rounded-sm", className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            "data-test": "ribbon",
            className: "block",
            children: children
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Badge);


/***/ }),

/***/ 48457:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CARD_TYPES": function() { return /* binding */ CARD_TYPES; },
  "default": function() { return /* binding */ product_card; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(69779);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/contexts/tracking.tsx + 1 modules
var tracking = __webpack_require__(70315);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/tracking/index.ts
var src_tracking = __webpack_require__(1975);
// EXTERNAL MODULE: ./src/tracking/gtm/index.ts + 1 modules
var gtm = __webpack_require__(71295);
// EXTERNAL MODULE: ./src/components/badge/index.tsx
var badge = __webpack_require__(50490);
// EXTERNAL MODULE: ./src/components/judge-me-preview-badge/index.tsx
var judge_me_preview_badge = __webpack_require__(42657);
// EXTERNAL MODULE: ./src/components/price/index.tsx
var components_price = __webpack_require__(47969);
// EXTERNAL MODULE: ./src/config.ts
var config = __webpack_require__(86704);
// EXTERNAL MODULE: ./src/contexts/common.tsx + 5 modules
var common = __webpack_require__(21310);
// EXTERNAL MODULE: ./src/contexts/segmentation.tsx + 3 modules
var segmentation = __webpack_require__(42067);
// EXTERNAL MODULE: ./src/hooks/common/use-is-client.tsx
var use_is_client = __webpack_require__(7231);
// EXTERNAL MODULE: ./src/hooks/common/use-mobile.tsx
var use_mobile = __webpack_require__(44621);
// EXTERNAL MODULE: ./src/hooks/product/use-product.ts
var use_product = __webpack_require__(16740);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
// EXTERNAL MODULE: ./src/utils/has-personalized-discount.ts
var has_personalized_discount = __webpack_require__(29898);
// EXTERNAL MODULE: ./src/utils/image-loader.ts
var image_loader = __webpack_require__(6213);
// EXTERNAL MODULE: ./src/utils/product.ts
var utils_product = __webpack_require__(92284);
;// CONCATENATED MODULE: ./src/components/product-card/accentuate-badges/index.tsx






var AccentuateBadges = function(param) {
    var className = param.className, color = param.color, product = param.product, subTitle = param.subTitle, title = param.title;
    var globalDiscount = (0,common/* useCommon */.G)().globalDiscount;
    var hasDiscount = product ? (0,has_personalized_discount/* default */.Z)(product, globalDiscount) : false;
    var badges = [];
    if (title || subTitle) {
        badges.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)(badge/* default */.Z, {
            className: className,
            type: color === "Red-Sale" ? "Discount" : color === "Generic-Beige" ? "General" : "Limited",
            children: [
                title,
                " ",
                subTitle
            ]
        }, title));
    }
    if (hasDiscount) {
        var ref;
        badges.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(badge/* default */.Z, {
            className: className,
            type: "Discount",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                id: "cdp:tile:badge:save",
                values: {
                    amount: (ref = globalDiscount.discount) === null || ref === void 0 ? void 0 : ref.amountInPercent
                }
            })
        }, "discount"));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: badges.map(function(badge, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                children: badge
            }, index);
        })
    });
};
/* harmony default export */ var accentuate_badges = (AccentuateBadges);

;// CONCATENATED MODULE: ./src/components/product-card/content.tsx



















/**
 * Product Card Content. Displays product image, title, rating, price and subscription price.
 * @TODO : After migration to PDEX stacks, logics of discount calculations will be obsolete
 */ var Content = function(param) {
    var product = param.product, shouldShowBlackRibbon = param.shouldShowBlackRibbon, showSubscriptionPrice = param.showSubscriptionPrice, starSize = param.starSize, type = param.type, isBestSeller = param.isBestSeller;
    var ref;
    var isClient = (0,use_is_client/* default */.Z)().isClient;
    var isMobile = (0,use_mobile/* default */.Z)();
    var globalDiscount = (0,common/* useCommon */.G)().globalDiscount;
    var hasDiscount = (0,has_personalized_discount/* default */.Z)(product, globalDiscount, true);
    var productId = product.id, availableForSale = product.availableForSale;
    var ref1 = (0,use_product/* default */.Z)(product, {
        isSubscriptionSelected: showSubscriptionPrice
    }), comparePrice = ref1.comparePrice, price = ref1.price;
    var ref2 = (0,segmentation/* useSegmentationContext */.M)(), shouldOmitPersonalization = ref2.shouldOmitPersonalization, multipleSegmentation = ref2.multipleSegmentation;
    var subTitle = (0,react.useMemo)(function() {
        if (shouldOmitPersonalization) {
            return product.getProductSubtitle();
        }
        return product.getProductSubtitle({
            segmentation: multipleSegmentation === null || multipleSegmentation === void 0 ? void 0 : multipleSegmentation.lastSegmentation
        });
    }, [
        multipleSegmentation === null || multipleSegmentation === void 0 ? void 0 : multipleSegmentation.lastSegmentation,
        product,
        shouldOmitPersonalization, 
    ]);
    var shouldShowBadgesSection = type !== CARD_TYPES.SLIDER && isClient && (isBestSeller || product.getRibbon().ribbonText || shouldShowBlackRibbon);
    var displayTitle = (0,react.useMemo)(function() {
        return product.getProductTitle();
    }, [
        product
    ]);
    var ribbon = (0,react.useMemo)(function() {
        return product.getRibbon();
    }, [
        product
    ]);
    // QA Temporary: Used during PDEX transition
    var titleSource = product.getProductTitle() ? "accentuate" : "product";
    var subscriptionValue = hasDiscount ? (ref = globalDiscount.discount) === null || ref === void 0 ? void 0 : ref.firstSubscriptionOrderDiscount : config/* default.subscriptionDiscount */.Z.subscriptionDiscount;
    var firstCheapestAvailableSubsVariant = (0,react.useMemo)(function() {
        // if smart collection item is dealt here, we show price
        if (product.getIsSmartCollectionItem()) {
            return +product.variants[0].priceV2.amount;
        }
        var _firstCheapestAvailableSubsVariant = product.getFirstCheapestAvailableSubsVariant();
        return subscriptionValue && _firstCheapestAvailableSubsVariant ? (0,utils_product/* minusPercent */.xU)(+_firstCheapestAvailableSubsVariant.priceV2.amount, subscriptionValue) : null;
    }, [
        product,
        subscriptionValue
    ]);
    var badgeSection = (0,react.useMemo)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: shouldShowBlackRibbon ? /*#__PURE__*/ (0,jsx_runtime.jsx)(badge/* default */.Z, {
                type: "General",
                "data-test": "black-deals-badge",
                className: "bg-other-black! text-text-dark-bg-contrast-white!",
                children: "BLACK DEAL"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    isBestSeller && /*#__PURE__*/ (0,jsx_runtime.jsx)(badge/* default */.Z, {
                        type: "Bestseller",
                        "data-test": "personalized-ribbon-text",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                            id: "common:bestseller"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(accentuate_badges, {
                        title: ribbon.ribbonText,
                        subTitle: ribbon.ribbonText2,
                        color: ribbon.ribbonColor,
                        product: product,
                        "data-test": "accentuate-badges"
                    })
                ]
            })
        });
    }, [
        isBestSeller,
        product,
        ribbon.ribbonColor,
        ribbon.ribbonText,
        ribbon.ribbonText2,
        shouldShowBlackRibbon, 
    ]);
    var renderWeight = (0,react.useCallback)(function(weight, index, arr) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                weight,
                index < arr.length - 1 ? " / " : ""
            ]
        }, index);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()("group relative h-full min-h-[172px] w-full rounded-lg bg-other-white pl-2 pr-3 shadow-xs lg:px-2 lg:pb-4 lg:pt-2", type === CARD_TYPES.SLIDER && "px-2 py-3 lg:px-4 lg:pb-4 lg:pt-2"),
        "data-test": "product-card",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()("flex h-full gap-2 lg:flex-col lg:gap-2.5", shouldShowBadgesSection ? "pt-7 lg:pt-0" : "pt-2 lg:pt-0", type === CARD_TYPES.SLIDER || type === CARD_TYPES.SLIDER_LARGE ? "flex-col pb-0" : "pb-3"),
            "data-test": "product-card-content",
            children: [
                shouldShowBadgesSection && type === CARD_TYPES.REGULAR && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "absolute left-1.5 top-1.5 z-10 flex w-full gap-1.5 lg:left-2 lg:top-2",
                    "data-test": "badges-section",
                    children: badgeSection
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("flex items-center justify-center", !availableForSale && "opacity-70", type === CARD_TYPES.REGULAR && "min-h-[130px] min-w-[130px] lg:min-h-[223px] "),
                    "data-test": "product-image-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()("relative flex w-full items-center justify-center", type === CARD_TYPES.SLIDER && "h-full"),
                        "data-test": "product-image-wrapper",
                        children: [
                            !availableForSale && /*#__PURE__*/ (0,jsx_runtime.jsx)(badge/* default */.Z, {
                                className: "absolute left-[50%] top-[50%] z-10 flex h-10! w-full -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-sm bg-grey-50 text-sm text-text-primary",
                                "data-test": "out-of-stock-badge",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                    id: "pdp:buy-panel:product-out-stock"
                                })
                            }),
                            product.image.src && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()(""),
                                "data-test": "product-image",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()(type === CARD_TYPES.REGULAR && "transition-all duration-300 ease-in-out lg:group-hover:h-[200px] lg:group-hover:w-[200px]", type === CARD_TYPES.SLIDER_LARGE ? "h-[270px] w-[270px] lg:h-[272px] lg:w-[272px]" : "h-[130px] w-[130px] lg:h-[188px] lg:w-[188px]"),
                                    "data-test": "image-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        "data-test": "product-image-element",
                                        loader: image_loader/* generalImageLoader */.x,
                                        src: product.image.src,
                                        alt: product.image.alt || product.title || "",
                                        width: 800,
                                        height: 800,
                                        sizes: "(min-width: 1024px) 33vw, (min-width: 769px) 50vw, 50vw",
                                        className: "h-auto",
                                        loading: "lazy"
                                    })
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()("flex flex-col items-start gap-1 bg-other-white text-left align-top", type === CARD_TYPES.SLIDER && "p-0"),
                    "data-test": "product-data",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                            className: "line-clamp-2 w-full pt-2 font-mindset text-lg leading-6 tracking-wide text-text-light-bg-primary lg:pt-0",
                            "data-test": "product-title",
                            "data-test-pdp-title": product.getProductTitle(),
                            "data-test-title-source": titleSource,
                            children: displayTitle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(judge_me_preview_badge/* default */.Z, {
                            productId: productId,
                            numberDisplayType: "number",
                            starSize: starSize,
                            "data-test": "product-rating",
                            hideNumberOfReviews: type === CARD_TYPES.SLIDER && isMobile
                        }),
                        isClient && subTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            "data-test": "product-subtitle",
                            className: classnames_default()("text-sm leading-[18px] text-text-secondary", isMobile ? "line-clamp-4" : "line-clamp-2"),
                            children: subTitle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()("font-black", comparePrice ? "text-text-light-bg-discounted-price" : "text-text-light-bg-primary"),
                            "data-test": "product-price",
                            children: [
                                product.getShouldShowFromPrice() ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    "data-test": "price-from",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                            id: "cdp:general:price_from"
                                        }),
                                        "\xa0"
                                    ]
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_price/* default */.Z, {
                                        value: firstCheapestAvailableSubsVariant !== null && firstCheapestAvailableSubsVariant !== void 0 ? firstCheapestAvailableSubsVariant : price
                                    })
                                }),
                                comparePrice && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "ml-2 text-sm font-normal text-text-secondary line-through",
                                    "data-test": "compare-price",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_price/* default */.Z, {
                                        value: comparePrice
                                    })
                                }),
                                " "
                            ]
                        })
                    ]
                }),
                type === CARD_TYPES.REGULAR && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "hidden text-left text-text-secondary lg:line-clamp-2",
                    "data-test": "product-weights",
                    children: product.getWeights().map(renderWeight)
                })
            ]
        })
    });
};
/* harmony default export */ var product_card_content = (/*#__PURE__*/(0,react.memo)(Content));

;// CONCATENATED MODULE: ./src/components/product-card/index.tsx











var CARD_TYPES = {
    SLIDER: "slider",
    SLIDER_LARGE: "slider large",
    REGULAR: "regular"
};
/**
 * Product Card. Wrapper for Product Card Content.
 * Includes tracking and navigation.
 */ var ProductCard = function(param) {
    var className = param.className, collectionTitle = param.collectionTitle, isBestSeller = param.isBestSeller, position = param.position, product = param.product, shouldShowBlackRibbon = param.shouldShowBlackRibbon, _showSubscriptionPrice = param.showSubscriptionPrice, showSubscriptionPrice = _showSubscriptionPrice === void 0 ? false : _showSubscriptionPrice, starSize = param.starSize, trackingElementName = param.trackingElementName, _type = param.type, type = _type === void 0 ? CARD_TYPES.REGULAR : _type, onTileClick = param.onTileClick, additionalQuery = param.additionalQuery;
    var productId = product.id, productTitle = product.title, handle = product.handle;
    var setTrackedList = (0,tracking/* useTrackingContext */.E)().setTrackedList;
    var onGoToProduct = (0,react.useCallback)(function() {
        trackingElementName && (0,gtm/* gtm */.w)((0,src_tracking/* selectElement */.G7)({
            element: (0,_to_consumable_array/* default */.Z)(Array.isArray(trackingElementName) ? trackingElementName : [
                trackingElementName
            ]).concat([
                productTitle, 
            ])
        }));
        var tags = product.tags, productType = product.productType;
        (0,gtm/* gtm */.w)({
            group: gtm/* Gtm.GroupName.Product */.P.Df.Product,
            name: gtm/* Gtm.ProductEventName.Click */.P.MB.Click,
            data: {
                product: {
                    productTitle: productTitle,
                    productId: productId,
                    productType: productType,
                    tags: tags.join(","),
                    position: position,
                    list: collectionTitle || ""
                }
            }
        });
        setTrackedList(+productId, collectionTitle || "");
    }, [
        productId,
        productTitle,
        collectionTitle,
        position,
        product,
        trackingElementName,
        setTrackedList, 
    ]);
    var promotedVariant = (0,react.useMemo)(function() {
        return product.variants.find(function(variant) {
            return variant.id === product.promoteVariantId;
        });
    }, [
        product
    ]);
    var link = (0,react.useMemo)(function() {
        var queryObj = {};
        if (product.promoteVariantId && (promotedVariant === null || promotedVariant === void 0 ? void 0 : promotedVariant.availableForSale)) {
            queryObj = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, queryObj), {
                variant: product.promoteVariantId
            });
        }
        if (additionalQuery) {
            queryObj = (0,_object_spread/* default */.Z)({}, queryObj, additionalQuery);
        }
        var searchParam = new URLSearchParams(queryObj);
        return "/products/".concat(handle).concat(searchParam.size > 0 ? "?" + searchParam.toString() : "");
    }, [
        additionalQuery,
        handle,
        product.promoteVariantId,
        promotedVariant === null || promotedVariant === void 0 ? void 0 : promotedVariant.availableForSale, 
    ]);
    var content = /*#__PURE__*/ (0,jsx_runtime.jsx)(product_card_content, {
        isBestSeller: isBestSeller,
        product: product,
        showSubscriptionPrice: showSubscriptionPrice,
        starSize: starSize,
        type: type,
        shouldShowBlackRibbon: shouldShowBlackRibbon
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: onTileClick ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            className: classnames_default()("focus-default flex h-full w-full decoration-transparent", className),
            onClick: onTileClick,
            children: content
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: link,
            passHref: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: classnames_default()("focus-default flex h-full w-full decoration-transparent", className),
                onClick: onGoToProduct,
                children: content
            })
        })
    });
};
/* harmony default export */ var product_card = (ProductCard);


/***/ }),

/***/ 49997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);


/**
 * ProductCardSkeleton Component
 */ var ProductCardSkeleton = function(param) {
    var isSlider = param.isSlider;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(isSlider ? "h-[312px] flex-col items-start lg:h-[356px]" : "items-center lg:h-[466px]", "flex h-[172px] gap-2 rounded-sm bg-other-white py-3 pl-2 pr-3 shadow-sm lg:flex-col lg:items-start"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(isSlider ? "w-full" : "w-2/5", "h-32 animate-pulse rounded-lg bg-grey-100 px-12 py-8 lg:h-46 lg:w-full")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(isSlider ? "w-full" : "w-3/5", "flex h-32 flex-col justify-between gap-2.5 lg:w-full"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "h-3.5 w-3/4 shrink-0 animate-pulse rounded-2xl bg-grey-100"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "h-3.5 w-1/2 shrink-0 animate-pulse rounded-2xl bg-grey-100"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "h-2.5 w-4/5 shrink-0 animate-pulse rounded-2xl bg-grey-100 lg:h-4"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "hidden h-4 w-4/6 shrink-0 animate-pulse rounded-2xl bg-grey-100 lg:block"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(isSlider ? "h-3" : "hidden h-4", "w-full shrink-0 animate-pulse rounded-2xl bg-grey-100 lg:block")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(isSlider ? "h-3" : "h-2.5", "w-4/5 shrink-0 rounded-2xl bg-grey-100 lg:hidden lg:h-4")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(isSlider ? "h-3" : "h-2.5", "w-2/3 shrink-0 rounded-2xl bg-grey-100 lg:hidden lg:h-4 lg:w-3/5")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex w-1/4 shrink-0 gap-3 lg:w-1/4",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "h-2.5 w-full shrink-0 rounded-2xl bg-grey-100 lg:h-4"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "h-2.5 w-full shrink-0 rounded-2xl bg-grey-100 lg:h-4"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductCardSkeleton);


/***/ }),

/***/ 40321:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69779);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var contexts_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21310);
/* harmony import */ var hooks_gtm_use_impression_tracking__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93579);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var tracking__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1975);






/**
 * Set up product impressions, interacting with setProductImpressionsQueue via common provider
 */ var ProductImpressionsTracker = function(param) {
    var children = param.children, collectionHandle = param.collectionHandle, element = param.element, list = param.list, _options = param.options, options = _options === void 0 ? {
        threshold: 0.5
    } : _options, position = param.position, product = param.product, trackingGroupName = param.trackingGroupName;
    var ref = (0,contexts_common__WEBPACK_IMPORTED_MODULE_1__/* .useCommon */ .G)(), setQueue = ref.setProductImpressionsQueue;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    (0,hooks_gtm_use_impression_tracking__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        impressionStoreKey: trackingGroupName,
        impressionId: "".concat(product.id, "-").concat(product.promoteVariantId || 0),
        trackingFn: function(isInViewport) {
            if (isInViewport) {
                setQueue(function(prev) {
                    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(prev).concat([
                        {
                            productId: product.id,
                            productType: product.productType,
                            productTitle: product.title,
                            tags: Array.isArray(product.tags) ? product.tags : product.tags.split(","),
                            list: list,
                            position: position
                        }, 
                    ]);
                });
                if (position + 1 === 3 || position + 1 === 9) {
                    (0,tracking__WEBPACK_IMPORTED_MODULE_4__/* .gtm */ .wT)((0,tracking__WEBPACK_IMPORTED_MODULE_4__/* .viewElement */ .Ye)({
                        element: collectionHandle ? [
                            element,
                            "".concat(collectionHandle),
                            "n=".concat(position + 1)
                        ] : [
                            element,
                            "n=".concat(position + 1)
                        ],
                        list: list
                    }));
                }
            }
        },
        ref: ref1,
        options: options,
        debounce: 100
    });
    var child = react__WEBPACK_IMPORTED_MODULE_3__.Children.only(children);
    if (/*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_3__.isValidElement)(child)) {
        return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_3__.cloneElement)(child, {
            ref: ref1
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductImpressionsTracker);


/***/ }),

/***/ 31859:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ ALL_AVAILABLE_FILTERS; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67573);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14251);
/* harmony import */ var constants_collection_handles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52234);



var ALL_AVAILABLE_FILTERS = {
    "nutritional-needs": {
        tags: [
            "sehr-wahlerisch",
            "verdauungsprobleme",
            "unvertraglichkeiten-allergien",
            "haut-and-fellprobleme",
            "bestimmte-erkrankung",
            "pickyeatercat",
            "digestioncat",
            "overweightcat",
            "outdoorcat",
            "sterilizedcat",
            "ubergewicht", 
        ],
        compare: "AND"
    },
    "feed-type": {
        tags: [
            "nassfutter",
            "trockenfutter",
            "barf",
            "snacks"
        ]
    },
    sorts: {
        tags: [
            "huhn",
            "rind",
            "ente",
            "pute",
            "kalb",
            "wild",
            "lachs",
            "pferd",
            "lamm",
            "vegan",
            "ziege",
            "kanguru",
            "hirsch",
            "thunfisch",
            "forelle",
            "wasserbuffel",
            "kaninchen",
            "straus",
            "geflugel",
            "truthahn",
            "bowls-and-similars",
            "toys",
            "walking",
            "sleeping",
            "other-accessories", 
        ]
    },
    desires: {
        tags: [
            "getreidefrei",
            "glutenfrei",
            "hypoallergen",
            "monoprotein",
            "low-energy",
            "high-energy", 
        ],
        compare: "AND"
    },
    age: {
        tags: [
            "welpe",
            "adult",
            "senior",
            "kitten"
        ]
    },
    sizes: {
        tags: [
            "klein"
        ]
    },
    line: {
        tags: [
            "classic",
            "sensitiv",
            "mini",
            "green",
            "extra-meat",
            "limited",
            "superfood",
            "kaltgepresst",
            "softies",
            "happchen",
            "pasteten",
            "kausnacks",
            "pure-meat",
            "feinschmecker-pate",
            "saucen-menu",
            "genieser-filets",
            "filet-menu",
            "akzeptanz",
            "creme-snack",
            "soft-snacks",
            "filet-snack",
            "suppe",
            "gefriergetrocknet", 
        ]
    },
    funktion: {
        tags: [
            "gelenk",
            "haut-and-fell",
            "zeckensaison",
            "denta",
            "entspannung",
            "leber",
            "verdauung",
            "erkaltung",
            "digestion",
            "busy",
            "smart-accessories", 
        ]
    },
    "snack-type": {
        tags: [
            "knochen-and-kaurollen",
            "trainingssnacks",
            "zahnpflege",
            "functional-snacks",
            "pasten-and-cremesnacks",
            "hundekekse",
            "kaustreifen-and-sticks",
            "toppers",
            "creme-snack",
            "filet-snack",
            "suppe",
            "soft-snacks",
            "sensitiv",
            "pasten", 
        ]
    },
    "hero-filter": {
        tags: [
            "nassfutter",
            "trockenfutter",
            "barf",
            "snacks"
        ]
    },
    "health-needs": {
        tags: [
            "gelenk",
            "haut-and-fell",
            "zeckensaison",
            "denta",
            "entspannung",
            "leber",
            "verdauung",
            "erkaltung",
            "ungeziefer", 
        ]
    }
};
var _obj;
/**
 * Config to define filter for each collection.
 */ var FILTER_CONFIG = (_obj = {
    "test-cdp-qa": {
        sorts: {
            tags: [
                "rind",
                "kalb"
            ]
        },
        line: {
            tags: [
                "bundle"
            ]
        }
    },
    "fur-hunde-nassfutter": {
        "nutritional-needs": {
            tags: [
                "sehr-wahlerisch",
                "verdauungsprobleme",
                "unvertraglichkeiten-allergien",
                "haut-and-fellprobleme",
                "bestimmte-erkrankung", 
            ],
            compare: "AND"
        },
        age: {
            tags: [
                "welpe",
                "adult-1-6-jahre",
                "senior-7-jahre"
            ]
        },
        sorts: {
            tags: [
                "geflugel",
                "rind-and-kalb",
                "wild",
                "fisch",
                "lamm",
                "pferd",
                "ziege",
                "kanguru",
                "insekten",
                "vegetarisch-vegan", 
            ]
        }
    },
    "fur-hunde-trockenfutter": {
        "nutritional-needs": {
            tags: [
                "sehr-wahlerisch",
                "verdauungsprobleme",
                "unvertraglichkeiten-allergien",
                "haut-and-fellprobleme", 
            ],
            compare: "AND"
        },
        age: {
            tags: [
                "welpe",
                "adult-1-6-jahre",
                "senior-7-jahre"
            ]
        },
        sorts: {
            tags: [
                "geflugel",
                "rind-and-kalb",
                "wild",
                "fisch",
                "lamm",
                "pferd",
                "insekten",
                "vegetarisch-vegan", 
            ]
        },
        line: {
            tags: [
                "soft",
                "classic",
                "green",
                "superfood",
                "junior",
                "hypocare"
            ]
        }
    },
    "fur-hunde-nassfutter-storys": {
        sorts: {
            tags: [
                "huhn",
                "rind",
                "ente",
                "pute",
                "kalb",
                "wild",
                "lachs",
                "pferd",
                "lamm",
                "vegan",
                "ziege",
                "kanguru",
                "hirsch", 
            ]
        },
        desires: {
            tags: [
                "getreidefrei",
                "glutenfrei",
                "hypoallergen",
                "monoprotein",
                "low-energy",
                "high-energy", 
            ],
            compare: "AND"
        },
        age: {
            tags: [
                "welpe",
                "adult",
                "senior"
            ]
        },
        sizes: {
            tags: [
                "klein"
            ]
        },
        line: {
            tags: [
                "classic",
                "sensitiv",
                "vet",
                "mini",
                "breed-fit",
                "green",
                "extra-meat",
                "limited", 
            ]
        }
    },
    "fur-hunde-nassfutter-test": {
        "special-desires": {
            tags: [
                "fur-welpen",
                "fur-senioren",
                "getreide-glutenfrei",
                "ohne-kartoffeln",
                "fur-allergiker",
                "sensible-verdauung",
                "weniger-kalorien",
                "fur-aktive-hunde",
                "fur-kleine-rassen",
                "spezielle-erkrankungen", 
            ],
            compare: "AND"
        },
        taste: {
            tags: [
                "geflugel",
                "rind-kalb",
                "wild",
                "fisch",
                "lamm",
                "pferd",
                "ziege",
                "kanguru",
                "insekten",
                "vegetarisch-vegan", 
            ]
        }
    },
    "fur-hunde-barf-frische-menus": {
        "nutritional-needs": {
            tags: [
                "sehr-wahlerisch",
                "verdauungsprobleme",
                "unvertraglichkeiten-allergien",
                "haut-and-fellprobleme", 
            ],
            compare: "AND"
        },
        age: {
            tags: [
                "welpe",
                "adult-1-6-jahre",
                "senior-7-jahre"
            ]
        },
        sorts: {
            tags: [
                "huhn",
                "rind",
                "wild",
                "pferd",
                "kanguru",
                "wasserbuffel",
                "lamm", 
            ]
        }
    },
    "fur-hunde-snacks": {
        "snack-type": {
            tags: [
                "knochen-and-kaurollen",
                "trainingssnacks",
                "zahnpflege",
                "functional-snacks",
                "pasten-and-cremesnacks",
                "hundekekse",
                "kaustreifen-and-sticks",
                "toppers", 
            ]
        },
        "nutritional-needs": {
            tags: [
                "sehr-wahlerisch",
                "verdauungsprobleme",
                "unvertraglichkeiten-allergien",
                "haut-and-fellprobleme", 
            ],
            compare: "AND"
        },
        age: {
            tags: [
                "welpe",
                "adult-1-6-jahre",
                "senior-7-jahre"
            ]
        },
        sorts: {
            tags: [
                "geflugel",
                "rind-and-kalb",
                "wild",
                "fisch",
                "lamm",
                "pferd",
                "ziege",
                "kanguru",
                "kaninchen",
                "straus",
                "schwein",
                "insekten",
                "vegetarisch-vegan", 
            ]
        }
    },
    "fur-hunde-nahrungserganzung": {
        age: {
            tags: [
                "welpe",
                "adult-1-6-jahre",
                "senior-7-jahre"
            ]
        }
    },
    "fur-hunde-gesundheit": {
        "health-needs": {
            tags: [
                "gelenk",
                "haut-and-fell",
                "zeckensaison",
                "denta",
                "entspannung",
                "leber",
                "verdauung",
                "erkaltung",
                "ungeziefer", 
            ]
        },
        "nutritional-needs": {
            tags: [
                "sehr-wahlerisch",
                "verdauungsprobleme",
                "unvertraglichkeiten-allergien",
                "haut-and-fellprobleme",
                "bestimmte-erkrankung", 
            ]
        },
        line: {
            tags: [
                "vet"
            ]
        }
    },
    "fur-hunde-zubehor": {
        sorts: {
            tags: [
                "bowls-and-similars",
                "toys",
                "walking",
                "sleeping",
                "other-accessories", 
            ]
        },
        funktion: {
            tags: [
                "digestion",
                "busy",
                "smart-accessories"
            ]
        }
    },
    "fur-hunde-futter-fur-kleine-rassen": {
        "feed-type": {
            tags: [
                "nassfutter",
                "trockenfutter",
                "barf",
                "snacks"
            ]
        },
        sorts: {
            tags: [
                "huhn",
                "rind",
                "ente",
                "pute",
                "lamm"
            ]
        }
    },
    "fur-hunde-welpen-und-junghunde": {
        "feed-type": {
            tags: [
                "nassfutter",
                "trockenfutter",
                "barf",
                "snacks"
            ]
        },
        sorts: {
            tags: [
                "geflugel",
                "rind",
                "lachs",
                "lamm",
                "ente",
                "pferd",
                "wasserbuffel",
                "kanguru", 
            ]
        }
    },
    "fur-hunde-welpen-und-junghunde-lp1": {
        "feed-type": {
            tags: [
                "nassfutter",
                "trockenfutter",
                "barf",
                "snacks"
            ]
        },
        sorts: {
            tags: [
                "geflugel",
                "rind",
                "lachs",
                "lamm",
                "ente",
                "pferd",
                "wasserbuffel",
                "kanguru", 
            ]
        }
    },
    "fur-hunde-beliebte-produkte": {
        sorts: {
            tags: [
                "geflugel",
                "rind-and-kalb",
                "wild",
                "fisch",
                "lamm",
                "pferd",
                "ziege",
                "kanguru",
                "insekten",
                "vegetarisch-vegan",
                "schwein", 
            ]
        },
        "nutritional-needs": {
            tags: [
                "sehr-wahlerisch",
                "verdauungsprobleme",
                "unvertraglichkeiten-allergien",
                "haut-and-fellprobleme", 
            ]
        },
        age: {
            tags: [
                "welpe",
                "adult-1-6-jahre",
                "senior-7-jahre"
            ]
        },
        "hero-filter": {
            tags: [
                "nassfutter",
                "trockenfutter",
                "barf",
                "snacks"
            ]
        }
    },
    "fur-hunde-sensitiv": {
        sorts: {
            tags: [
                "geflugel",
                "rind-and-kalb",
                // 'wild',
                "fisch",
                "lamm",
                "pferd",
                // 'insekten',
                // 'vegetarisch-vegan',
                "ziege",
                "kanguru", 
            ]
        },
        "feed-type": {
            tags: [
                "nassfutter",
                "trockenfutter",
                "barf",
                "snacks"
            ]
        }
    },
    "fur-hunde-haut-fellprobleme": {
        "feed-type": {
            tags: [
                "nassfutter",
                "trockenfutter",
                "barf",
                "snacks"
            ]
        },
        sorts: {
            tags: [
                "geflugel",
                "rind-and-kalb",
                "fisch",
                "pferd",
                "ziege"
            ]
        }
    },
    "fur-hunde-haut-fellprobleme-lp": {
        "feed-type": {
            tags: [
                "nassfutter",
                "trockenfutter",
                "barf",
                "snacks"
            ]
        },
        sorts: {
            tags: [
                "geflugel",
                "rind-and-kalb",
                "fisch",
                "pferd",
                "ziege"
            ]
        }
    },
    "fur-hunde-verdauungsprobleme": {
        "feed-type": {
            tags: [
                "nassfutter",
                "trockenfutter",
                "barf",
                "snacks"
            ]
        },
        sorts: {
            tags: [
                "geflugel",
                "fisch",
                "pferd",
                "ziege",
                "vegetarisch-vegan"
            ]
        }
    },
    "fur-hunde-verdauungsprobleme-lp": {
        sorts: {
            tags: [
                "geflugel",
                "fisch",
                "pferd",
                "ziege",
                "vegetarisch-vegan"
            ]
        },
        "feed-type": {
            tags: [
                "nassfutter",
                "trockenfutter",
                "barf",
                "snacks"
            ]
        }
    },
    "fur-hunde-verdauungsprobleme-lp1": {
        sorts: {
            tags: [
                "geflugel",
                "fisch",
                "pferd",
                "ziege",
                "vegetarisch-vegan"
            ]
        },
        "feed-type": {
            tags: [
                "nassfutter",
                "trockenfutter",
                "barf",
                "snacks"
            ]
        }
    },
    "fur-hunde-verdauungsprobleme-lp2": {
        sorts: {
            tags: [
                "geflugel",
                "fisch",
                "pferd",
                "ziege",
                "vegetarisch-vegan"
            ]
        },
        "feed-type": {
            tags: [
                "nassfutter",
                "trockenfutter",
                "barf",
                "snacks"
            ]
        }
    },
    "fur-hunde-sehr-wahlerisch": {
        sorts: {
            tags: [
                "geflugel",
                "rind-and-kalb",
                "lamm",
                "schwein"
            ]
        },
        "feed-type": {
            tags: [
                "nassfutter",
                "trockenfutter",
                "barf",
                "snacks"
            ]
        }
    },
    "fur-hunde-unvertraeglichkeiten-allergien": {
        "feed-type": {
            tags: [
                "nassfutter",
                "trockenfutter",
                "barf",
                "snacks"
            ]
        },
        sorts: {
            tags: [
                "geflugel",
                "wild",
                "pferd",
                "ziege",
                "kanguru",
                "insekten",
                "vegetarisch-vegan", 
            ]
        }
    },
    "fur-hunde-unvertraeglichkeiten-allergien-lp": {
        sorts: {
            tags: [
                "geflugel",
                "wild",
                "pferd",
                "ziege",
                "kanguru",
                "insekten",
                "vegetarisch-vegan", 
            ]
        },
        "feed-type": {
            tags: [
                "nassfutter",
                "trockenfutter",
                "barf",
                "snacks"
            ]
        }
    },
    "fur-hunde-unvertraeglichkeiten-allergien-lp1": {
        sorts: {
            tags: [
                "geflugel",
                "wild",
                "pferd",
                "ziege",
                "kanguru",
                "insekten",
                "vegetarisch-vegan", 
            ]
        },
        "feed-type": {
            tags: [
                "nassfutter",
                "trockenfutter",
                "barf",
                "snacks"
            ]
        }
    },
    "fur-hunde-unvertraeglichkeiten-allergien-lp2": {
        sorts: {
            tags: [
                "geflugel",
                "wild",
                "pferd",
                "ziege",
                "kanguru",
                "insekten",
                "vegetarisch-vegan", 
            ]
        },
        "feed-type": {
            tags: [
                "nassfutter",
                "trockenfutter",
                "barf",
                "snacks"
            ]
        }
    },
    "fur-hunde-sehr-waehlerisch": {
        "feed-type": {
            tags: [
                "nassfutter",
                "trockenfutter",
                "barf",
                "snacks"
            ]
        },
        sorts: {
            tags: [
                "geflugel",
                "rind-and-kalb",
                "lamm",
                "schwein"
            ]
        }
    },
    "fur-hunde-sehr-waehlerisch-lp": {
        "feed-type": {
            tags: [
                "nassfutter",
                "trockenfutter",
                "barf",
                "snacks"
            ]
        },
        sorts: {
            tags: [
                "geflugel",
                "rind-and-kalb",
                "lamm",
                "schwein"
            ]
        }
    },
    "fur-hunde-sehr-waehlerisch-lp1": {
        "feed-type": {
            tags: [
                "nassfutter",
                "trockenfutter",
                "barf",
                "snacks"
            ]
        },
        sorts: {
            tags: [
                "geflugel",
                "rind-and-kalb",
                "lamm",
                "schwein"
            ]
        }
    },
    "fur-hunde-sehr-waehlerisch-lp2": {
        "feed-type": {
            tags: [
                "nassfutter",
                "trockenfutter",
                "barf",
                "snacks"
            ]
        },
        sorts: {
            tags: [
                "geflugel",
                "rind-and-kalb",
                "lamm",
                "schwein"
            ]
        }
    },
    "fur-hunde-alle-fleischsorten-lp": {
        sorts: {
            tags: [
                "geflugel",
                "rind-and-kalb",
                "wild",
                "fisch",
                "lamm",
                "pferd",
                "ziege",
                "kanguru",
                "insekten",
                "vegetarisch-vegan",
                "wasserbuffel",
                "schwein", 
            ]
        },
        "nutritional-needs": {
            tags: [
                "sehr-wahlerisch",
                "verdauungsprobleme",
                "unvertraglichkeiten-allergien",
                "haut-and-fellprobleme",
                "bestimmte-erkrankung", 
            ]
        },
        age: {
            tags: [
                "welpe",
                "adult-1-6-jahre",
                "senior-7-jahre"
            ]
        },
        "hero-filter": {
            tags: [
                "nassfutter",
                "trockenfutter",
                "barf",
                "snacks"
            ]
        }
    },
    "fur-hunde-uebergewicht": {
        "feed-type": {
            tags: [
                "nassfutter",
                "trockenfutter",
                "snacks"
            ]
        },
        sorts: {
            tags: [
                "geflugel",
                "rind-and-kalb",
                "fisch",
                "insekten"
            ]
        }
    }
}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, constants_collection_handles__WEBPACK_IMPORTED_MODULE_0__/* .Handles.allProductsForDog */ .w.allProductsForDog, {
    sorts: {
        tags: [
            "geflugel",
            "rind-and-kalb",
            "wild",
            "fisch",
            "lamm",
            "pferd",
            "ziege",
            "kanguru",
            "insekten",
            "vegetarisch-vegan",
            "wasserbuffel",
            "schwein", 
        ]
    },
    "nutritional-needs": {
        tags: [
            "sehr-wahlerisch",
            "verdauungsprobleme",
            "unvertraglichkeiten-allergien",
            "haut-and-fellprobleme",
            "bestimmte-erkrankung", 
        ]
    },
    age: {
        tags: [
            "welpe",
            "adult-1-6-jahre",
            "senior-7-jahre"
        ]
    },
    "hero-filter": {
        tags: [
            "nassfutter",
            "trockenfutter",
            "barf",
            "snacks"
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-hunde-ohne-zucker-lp", {
    sorts: {
        tags: [
            "geflugel",
            "rind-and-kalb",
            "wild",
            "lamm",
            "pferd",
            "insekten"
        ]
    },
    "nutritional-needs": {
        tags: [
            "sehr-wahlerisch",
            "verdauungsprobleme",
            "unvertraglichkeiten-allergien",
            "haut-and-fellprobleme", 
        ]
    },
    age: {
        tags: [
            "welpe",
            "adult-1-6-jahre",
            "senior-7-jahre"
        ]
    },
    "feed-type": {
        tags: [
            "nassfutter",
            "trockenfutter",
            "barf",
            "snacks"
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-hunde-nassfutter-lp", {
    sorts: {
        tags: [
            "geflugel",
            "rind-and-kalb",
            "wild",
            "fisch",
            "lamm",
            "pferd",
            "insekten",
            "vegetarisch-vegan", 
        ]
    },
    "nutritional-needs": {
        tags: [
            "sehr-wahlerisch",
            "verdauungsprobleme",
            "unvertraglichkeiten-allergien",
            "haut-and-fellprobleme", 
        ]
    },
    age: {
        tags: [
            "welpe",
            "adult-1-6-jahre",
            "senior-7-jahre"
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-hunde-nassfutter-lp-2", {
    sorts: {
        tags: [
            "huhn",
            "rind",
            "ente",
            "pute",
            "kalb",
            "wild",
            "lachs",
            "pferd",
            "lamm",
            "vegan",
            "ziege",
            "kanguru",
            "hirsch", 
        ]
    },
    desires: {
        tags: [
            "getreidefrei",
            "glutenfrei",
            "hypoallergen",
            "monoprotein",
            "low-energy",
            "high-energy", 
        ],
        compare: "AND"
    },
    age: {
        tags: [
            "welpe",
            "adult",
            "senior"
        ]
    },
    sizes: {
        tags: [
            "klein"
        ]
    },
    line: {
        tags: [
            "classic",
            "sensitiv",
            "vet",
            "mini",
            "breed-fit",
            "green",
            "extra-meat",
            "limited", 
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-hunde-barf-frische-menus-lp-2", {
    sorts: {
        tags: [
            "huhn",
            "rind",
            "wild",
            "pferd",
            "kanguru",
            "wasserbuffel",
            "hirsch",
            "lamm", 
        ]
    },
    desires: {
        tags: [
            "getreidefrei",
            "glutenfrei",
            "hypoallergen",
            "monoprotein"
        ],
        compare: "AND"
    },
    age: {
        tags: [
            "welpe",
            "adult",
            "senior"
        ]
    },
    line: {
        tags: [
            "classic",
            "sensitiv"
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-hunde-trockenfutter-lp", {
    sorts: {
        tags: [
            "huhn",
            "rind",
            "ente",
            "pute",
            "kalb",
            "wild",
            "lachs",
            "lamm",
            "thunfisch",
            "forelle",
            "hirsch",
            "pferd", 
        ]
    },
    desires: {
        tags: [
            "getreidefrei",
            "glutenfrei",
            "hypoallergen",
            "monoprotein",
            "low-energy",
            "high-energy", 
        ],
        compare: "AND"
    },
    age: {
        tags: [
            "welpe",
            "adult",
            "senior"
        ]
    },
    sizes: {
        tags: [
            "klein"
        ]
    },
    line: {
        tags: [
            "classic",
            "sensitiv",
            "mini",
            "superfood",
            "kaltgepresst",
            "green", 
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-hunde-barf-frische-menus-lp", {
    sorts: {
        tags: [
            "huhn",
            "rind",
            "pferd",
            "kanguru",
            "wasserbuffel",
            "hirsch",
            "lamm", 
        ]
    },
    "nutritional-needs": {
        tags: [
            "sehr-wahlerisch",
            "verdauungsprobleme",
            "unvertraglichkeiten-allergien",
            "haut-and-fellprobleme", 
        ]
    },
    age: {
        tags: [
            "welpe",
            "adult-1-6-jahre"
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-hunde-snacks-lp", {
    sorts: {
        tags: [
            "geflugel",
            "rind-and-kalb",
            "wild",
            "fisch",
            "lamm",
            "pferd",
            "ziege",
            "kanguru",
            "kaninchen",
            "straus",
            "insekten",
            "vegetarisch-vegan",
            "schwein", 
        ]
    },
    "nutritional-needs": {
        tags: [
            "verdauungsprobleme",
            "unvertraglichkeiten-allergien",
            "haut-and-fellprobleme", 
        ]
    },
    age: {
        tags: [
            "welpe",
            "adult-1-6-jahre",
            "senior-7-jahre"
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-hunde-gesundheit-lp", {
    funktion: {
        tags: [
            "gelenk",
            "haut-and-fell",
            "zeckensaison",
            "denta",
            "entspannung",
            "leber",
            "verdauung",
            "erkaltung", 
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-hunde-welpen-und-junghunde-lp", {
    "feed-type": {
        tags: [
            "nassfutter",
            "trockenfutter",
            "barf",
            "snacks"
        ]
    },
    sorts: {
        tags: [
            "geflugel",
            "rind-and-kalb",
            "lachs",
            "lamm",
            "ente",
            "pferd",
            "kanguru",
            "wasserbuffel", 
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-hunde-getreidefreies-hundefutter", {
    "feed-type": {
        tags: [
            "nassfutter",
            "trockenfutter",
            "barf",
            "snacks"
        ]
    },
    sorts: {
        tags: [
            "geflugel",
            "rind-and-kalb",
            "wild",
            "fisch",
            "lamm",
            "pferd",
            "kanguru",
            "insekten",
            "vegetarisch-vegan",
            "schwein", 
        ]
    },
    "nutritional-needs": {
        tags: [
            "sehr-wahlerisch",
            "verdauungsprobleme",
            "unvertraglichkeiten-allergien",
            "haut-and-fellprobleme",
            "bestimmte-erkrankung", 
        ]
    },
    age: {
        tags: [
            "welpe",
            "adult-1-6-jahre",
            "senior-7-jahre"
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-hunde-hypoallergenes-hundefutter-lp", {
    sorts: {
        tags: [
            "pferd",
            "lamm",
            "ente",
            "wild",
            "ziege",
            "insekt",
            "vegetarisch-vegan",
            "kanguru",
            "wasserbuffel", 
        ]
    },
    "nutritional-needs": {
        tags: [
            "sehr-wahlerisch",
            "verdauungsprobleme",
            "unvertraglichkeiten-allergien",
            "haut-and-fellprobleme", 
        ]
    },
    age: {
        tags: [
            "welpe",
            "adult-1-6-jahre",
            "senior-7-jahre"
        ]
    },
    "feed-type": {
        tags: [
            "nassfutter",
            "trockenfutter",
            "barf",
            "snacks"
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-hunde-nahrungserganzung-lp", {
    "nutritional-needs": {
        tags: [
            "sehr-wahlerisch",
            "verdauungsprobleme",
            "unvertraglichkeiten-allergien",
            "haut-and-fellprobleme", 
        ]
    },
    age: {
        tags: [
            "welpe",
            "adult-1-6-jahre",
            "senior-7-jahre"
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-hunde-getreidefreies-hundefutter-ohne-getreide-lp", {
    sorts: {
        tags: [
            "huhn",
            "rind",
            "kalb",
            "pute",
            "pferd",
            "lamm",
            "wild",
            "geflugel",
            "thunfisch",
            "lachs",
            "forelle",
            "fisch", 
        ]
    },
    desires: {
        tags: [
            "monoprotein",
            "hypoallergen"
        ],
        compare: "AND"
    },
    age: {
        tags: [
            "welpe",
            "adult",
            "senior"
        ]
    },
    line: {
        tags: [
            "classic",
            "sensitiv",
            "green"
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-hunde-senior-lp", {
    sorts: {
        tags: [
            "geflugel",
            "rind-and-kalb",
            "wild",
            "fisch",
            "lamm",
            "pferd",
            "kanguru",
            "kaninchen",
            "straus",
            "insekten",
            "vegetarisch-vegan",
            "schwein", 
        ]
    },
    "feed-type": {
        tags: [
            "nassfutter",
            "trockenfutter",
            "barf",
            "snacks"
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-katzen-nassfutter", {
    "nutritional-needs": {
        tags: [
            "pickyeatercat",
            "digestioncat",
            "overweightcat",
            "outdoorcat",
            "sterilizedcat", 
        ]
    },
    line: {
        tags: [
            "saucen-menu",
            "pasteten",
            "mousse",
            "filet-menu",
            "silkycream",
            "juicyfilets",
            "puremeat",
            "meatypate",
            "vet",
            "limited", 
        ]
    },
    age: {
        tags: [
            "kitten",
            "adult",
            "senior"
        ]
    },
    sorts: {
        tags: [
            "huhn",
            "rind",
            "ente",
            "pute",
            "kalb",
            "wild",
            "lachs",
            "thunfisch",
            "kanguru",
            "kaninchen", 
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-hunde-chihuahua", {
    "feed-type": {
        tags: [
            "nassfutter",
            "trockenfutter",
            "snacks"
        ]
    },
    sorts: {
        tags: [
            "rind-and-kalb",
            "geflugel",
            "lamm"
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-hunde-chihuahua-lp", {
    "feed-type": {
        tags: [
            "nassfutter",
            "trockenfutter",
            "snacks"
        ]
    },
    sorts: {
        tags: [
            "rind-and-kalb",
            "geflugel",
            "lamm"
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-hunde-chihuahua-lp1", {
    "feed-type": {
        tags: [
            "nassfutter",
            "trockenfutter",
            "snacks"
        ]
    },
    sorts: {
        tags: [
            "rind-and-kalb",
            "geflugel",
            "lamm"
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-hunde-spitz", {
    "feed-type": {
        tags: [
            "nassfutter",
            "trockenfutter",
            "snacks"
        ]
    },
    sorts: {
        tags: [
            "rind-and-kalb",
            "fisch",
            "geflugel"
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-hunde-schaeferhund", {
    "feed-type": {
        tags: [
            "nassfutter",
            "trockenfutter",
            "snacks"
        ]
    },
    sorts: {
        tags: [
            "rind-and-kalb",
            "fisch",
            "geflugel",
            "insekten"
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-hunde-bulldogge", {
    "feed-type": {
        tags: [
            "nassfutter",
            "trockenfutter",
            "snacks"
        ]
    },
    sorts: {
        tags: [
            "pferd",
            "ziege",
            "kanguru",
            "wild",
            "geflugel",
            "fisch",
            "insekten", 
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-hunde-bulldogge-lp", {
    "feed-type": {
        tags: [
            "nassfutter",
            "trockenfutter",
            "snacks"
        ]
    },
    sorts: {
        tags: [
            "pferd",
            "ziege",
            "kanguru",
            "wild",
            "geflugel",
            "fisch",
            "insekten", 
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-hunde-bulldogge-lp1", {
    "feed-type": {
        tags: [
            "nassfutter",
            "trockenfutter",
            "snacks"
        ]
    },
    sorts: {
        tags: [
            "pferd",
            "ziege",
            "kanguru",
            "wild",
            "geflugel",
            "fisch",
            "insekten", 
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-hunde-bulldogge-lp2", {
    "feed-type": {
        tags: [
            "nassfutter",
            "trockenfutter",
            "snacks"
        ]
    },
    sorts: {
        tags: [
            "pferd",
            "ziege",
            "kanguru",
            "wild",
            "geflugel",
            "fisch",
            "insekten", 
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-hunde-mischling", {
    "feed-type": {
        tags: [
            "nassfutter",
            "trockenfutter",
            "snacks"
        ]
    },
    sorts: {
        tags: [
            "rind-and-kalb",
            "geflugel",
            "wild"
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-hunde-retriever", {
    "feed-type": {
        tags: [
            "nassfutter",
            "trockenfutter",
            "snacks"
        ]
    },
    sorts: {
        tags: [
            "geflugel",
            "lamm",
            "rind-and-kalb",
            "fisch",
            "insekten"
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-hunde-terrier", {
    "feed-type": {
        tags: [
            "nassfutter",
            "trockenfutter",
            "snacks"
        ]
    },
    sorts: {
        tags: [
            "rind-and-kalb",
            "wild",
            "fisch",
            "geflugel",
            "lamm"
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-hunde-terrier-lp", {
    "feed-type": {
        tags: [
            "nassfutter",
            "trockenfutter",
            "snacks"
        ]
    },
    sorts: {
        tags: [
            "rind-and-kalb",
            "wild",
            "fisch",
            "geflugel",
            "lamm"
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-hunde-pudel", {
    "feed-type": {
        tags: [
            "nassfutter",
            "trockenfutter",
            "snacks"
        ]
    },
    sorts: {
        tags: [
            "rind-and-kalb",
            "fisch",
            "geflugel",
            "pferd",
            "lamm",
            "wild"
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-hunde-malteser", {
    "feed-type": {
        tags: [
            "nassfutter",
            "trockenfutter",
            "snacks"
        ]
    },
    sorts: {
        tags: [
            "geflugel",
            "rind-and-kalb",
            "lamm"
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-hunde-dackel", {
    "feed-type": {
        tags: [
            "nassfutter",
            "trockenfutter",
            "snacks"
        ]
    },
    sorts: {
        tags: [
            "geflugel",
            "lamm",
            "rind-and-kalb",
            "fisch",
            "insekten"
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-hunde-dackel-lp", {
    "feed-type": {
        tags: [
            "nassfutter",
            "trockenfutter",
            "snacks"
        ]
    },
    sorts: {
        tags: [
            "geflugel",
            "lamm",
            "rind-and-kalb",
            "fisch",
            "insekten"
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-hunde-dackel-lp1", {
    "feed-type": {
        tags: [
            "nassfutter",
            "trockenfutter",
            "snacks"
        ]
    },
    sorts: {
        tags: [
            "geflugel",
            "lamm",
            "rind-and-kalb",
            "fisch",
            "insekten"
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-hunde-huetehunde", {
    "feed-type": {
        tags: [
            "nassfutter",
            "trockenfutter",
            "snacks"
        ]
    },
    sorts: {
        tags: [
            "geflugel",
            "rind-and-kalb",
            "wild",
            "fisch",
            "lamm"
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-katzen-trockenfutter", {
    sorts: {
        tags: [
            "huhn",
            "lachs",
            "geflugel",
            "thunfisch"
        ]
    },
    age: {
        tags: [
            "kitten",
            "adult",
            "senior"
        ]
    },
    "nutritional-needs": {
        tags: [
            "pickyeatercat",
            "digestioncat",
            "overweightcat",
            "outdoorcat",
            "sterilizedcat", 
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-katzen-barf-frische-menus", {
    sorts: {
        tags: [
            "huhn",
            "rind",
            "wild",
            "kanguru",
            "hirsch"
        ]
    },
    desires: {
        tags: [
            "getreidefrei",
            "glutenfrei",
            "hypoallergen"
        ],
        compare: "AND"
    },
    line: {
        tags: [
            "classic",
            "sensitiv"
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-katzen-snacks", {
    "snack-type": {
        tags: [
            "creme-snack",
            "filet-snack",
            "suppe",
            "soft-snacks",
            "sensitiv",
            "pasten", 
        ]
    },
    sorts: {
        tags: [
            "huhn",
            "ente",
            "pute",
            "wild",
            "lachs",
            "rind",
            "thunfisch",
            "hirsch", 
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-katzen-zubehor", {
    sorts: {
        tags: [
            "bowls-and-similars",
            "toys",
            "sleeping",
            "other-accessories"
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-katzen-nutze-deinen-vorteil-lp", {
    sorts: {
        tags: [
            "huhn",
            "rind",
            "ente",
            "pute",
            "kalb",
            "wild",
            "lachs",
            "lamm",
            "thunfisch",
            "kanguru",
            "kaninchen", 
        ]
    },
    desires: {
        tags: [
            "getreidefrei",
            "glutenfrei",
            "monoprotein",
            "hypoallergen"
        ],
        compare: "AND"
    },
    age: {
        tags: [
            "kitten",
            "adult",
            "senior"
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-katzen-nassfutter-lp", {
    sorts: {
        tags: [
            "huhn",
            "rind",
            "ente",
            "pute",
            "kalb",
            "wild",
            "lachs",
            "lamm",
            "thunfisch",
            "kanguru",
            "kaninchen", 
        ]
    },
    desires: {
        tags: [
            "getreidefrei",
            "glutenfrei",
            "hypoallergen"
        ],
        compare: "AND"
    },
    age: {
        tags: [
            "kitten",
            "adult",
            "senior"
        ]
    },
    line: {
        tags: [
            "classic",
            "sensitiv",
            "pure-meat",
            "feinschmecker-pate",
            "saucen-menu",
            "genieser-filets",
            "filet-menu",
            "mousse",
            "vet",
            "limited", 
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-katzen-trockenfutter-lp", {
    sorts: {
        tags: [
            "huhn",
            "lachs",
            "geflugel",
            "truthahn"
        ]
    },
    desires: {
        tags: [
            "getreidefrei",
            "glutenfrei",
            "hypoallergen"
        ],
        compare: "AND"
    },
    age: {
        tags: [
            "kitten",
            "adult",
            "senior"
        ]
    },
    line: {
        tags: [
            "classic",
            "sensitiv",
            "extra-meat"
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-katzen-barf-frische-menus-lp", {
    sorts: {
        tags: [
            "huhn",
            "rind",
            "wild",
            "kanguru",
            "hirsch"
        ]
    },
    desires: {
        tags: [
            "getreidefrei",
            "glutenfrei",
            "hypoallergen"
        ],
        compare: "AND"
    },
    line: {
        tags: [
            "classic",
            "sensitiv"
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-katzen-kitten-und-junge-katze-lp", {
    sorts: {
        tags: [
            "huhn",
            "rind",
            "ente",
            "pute",
            "kalb",
            "wild",
            "lachs",
            "lamm",
            "thunfisch",
            "kanguru",
            "kaninchen", 
        ]
    },
    desires: {
        tags: [
            "getreidefrei",
            "glutenfrei",
            "hypoallergen"
        ],
        compare: "AND"
    },
    line: {
        tags: [
            "classic",
            "sensitiv",
            "pure-meat",
            "feinschmecker-pate",
            "saucen-menu",
            "genieser-filets",
            "filet-menu",
            "mousse",
            "vet",
            "limited", 
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-katzen-alle-konsistenzen-lp", {
    sorts: {
        tags: [
            "huhn",
            "rind",
            "ente",
            "pute",
            "kalb",
            "wild",
            "lachs",
            "lamm",
            "thunfisch",
            "kanguru",
            "kaninchen", 
        ]
    },
    desires: {
        tags: [
            "getreidefrei",
            "glutenfrei",
            "hypoallergen"
        ],
        compare: "AND"
    },
    age: {
        tags: [
            "kitten",
            "adult",
            "senior"
        ]
    },
    line: {
        tags: [
            "classic",
            "sensitiv",
            "pure-meat",
            "feinschmecker-pate",
            "saucen-menu",
            "genieser-filets",
            "filet-menu",
            "mousse",
            "vet",
            "limited", 
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, constants_collection_handles__WEBPACK_IMPORTED_MODULE_0__/* .Handles.allProductsForCat */ .w.allProductsForCat, {
    "hero-filter": {
        tags: [
            "nassfutter",
            "trockenfutter",
            "snacks"
        ]
    },
    line: {
        tags: [
            "saucen-menu",
            "pasteten",
            "mousse",
            "filet-menu",
            "silkycream",
            "juicyfilets",
            "puremeat",
            "meatypate",
            "vet",
            "limited", 
        ]
    },
    "nutritional-needs": {
        tags: [
            "pickyeatercat",
            "digestioncat",
            "overweightcat",
            "outdoorcat",
            "sterilizedcat", 
        ]
    },
    age: {
        tags: [
            "kitten",
            "adult",
            "senior"
        ]
    },
    sorts: {
        tags: [
            "huhn",
            "rind",
            "ente",
            "pute",
            "kalb",
            "wild",
            "lachs",
            "thunfisch",
            "kanguru",
            "kaninchen", 
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-katzen-alle-fleischsorten-lp", {
    "hero-filter": {
        tags: [
            "nassfutter",
            "trockenfutter",
            "snacks"
        ]
    },
    line: {
        tags: [
            "saucen-menu",
            "pasteten",
            "mousse",
            "filet-menu"
        ]
    },
    "nutritional-needs": {
        tags: [
            "pickyeatercat",
            "digestioncat",
            "overweightcat",
            "outdoorcat",
            "sterilizedcat", 
        ]
    },
    age: {
        tags: [
            "kitten",
            "adult",
            "senior"
        ]
    },
    sorts: {
        tags: [
            "huhn",
            "rind",
            "ente",
            "pute",
            "kalb",
            "wild",
            "lachs",
            "thunfisch",
            "kanguru",
            "kaninchen", 
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-katzen-hypoallergenes-katzenfutter-lp", {
    sorts: {
        tags: [
            "kanguru",
            "hirsch",
            "ente",
            "wild"
        ]
    },
    age: {
        tags: [
            "kitten",
            "adult",
            "senior"
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-katzen-getreidefreies-katzenfutter-ohne-getreide-lp", {
    sorts: {
        tags: [
            "huhn",
            "rind",
            "ente",
            "pute",
            "kalb",
            "wild",
            "lachs",
            "lamm",
            "thunfisch",
            "kanguru",
            "kaninchen", 
        ]
    },
    desires: {
        tags: [
            "glutenfrei",
            "glutenfrei",
            "hypoallergen"
        ]
    },
    age: {
        tags: [
            "kitten",
            "adult",
            "senior"
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "probierpakete", {
    species: {
        tags: [
            "fur-hunde",
            "fur-katzen"
        ]
    },
    sorts: {
        tags: [
            "geflugel",
            "rind-and-kalb",
            "wild",
            "fisch",
            "lamm",
            "pferd",
            "ziege",
            "kanguru",
            "wasserbuffel",
            "insekten",
            "vegetarisch-vegan", 
        ]
    },
    "nutritional-needs": {
        tags: [
            "sehr-wahlerisch",
            "verdauungsprobleme",
            "unvertraglichkeiten-allergien",
            "haut-and-fellprobleme", 
        ]
    },
    age: {
        tags: [
            "kitten",
            "welpe",
            "adult-1-6-jahre",
            "senior-7-jahre"
        ]
    },
    // maybe it's better to leave it as it is for cat page
    desires: {
        tags: [
            "getreidefrei",
            "glutenfrei",
            "monoprotein",
            "hypoallergen"
        ],
        compare: "AND"
    },
    line: {
        tags: [
            "classic",
            "sensitiv",
            "green"
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-katzen-wahlerisch", {
    "feed-type": {
        tags: [
            "nassfutter",
            "trockenfutter",
            "snacks"
        ]
    },
    line: {
        tags: [
            "saucen-menu",
            "pasteten",
            "mousse",
            "filet-menu",
            "silkycream",
            "juicyfilets",
            "puremeat",
            "meatypate",
            "vet",
            "limited", 
        ]
    },
    sorts: {
        tags: [
            "huhn",
            "wild",
            "thunfisch",
            "pute",
            "lachs",
            "geflugel",
            "rind"
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-katzen-wahlerisch-lp", {
    "feed-type": {
        tags: [
            "nassfutter",
            "trockenfutter",
            "snacks"
        ]
    },
    line: {
        tags: [
            "saucen-menu",
            "pasteten",
            "mousse",
            "filet-menu"
        ]
    },
    sorts: {
        tags: [
            "huhn",
            "wild",
            "thunfisch",
            "pute",
            "lachs",
            "geflugel",
            "rind"
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-katzen-wahlerisch-lp1", {
    "feed-type": {
        tags: [
            "nassfutter",
            "trockenfutter",
            "snacks"
        ]
    },
    line: {
        tags: [
            "saucen-menu",
            "pasteten",
            "mousse",
            "filet-menu"
        ]
    },
    sorts: {
        tags: [
            "huhn",
            "wild",
            "thunfisch",
            "pute",
            "lachs",
            "geflugel",
            "rind"
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-katzen-verdauungsprobleme", {
    "feed-type": {
        tags: [
            "nassfutter",
            "trockenfutter",
            "snacks"
        ]
    },
    line: {
        tags: [
            "saucen-menu",
            "pasteten",
            "mousse",
            "filet-menu",
            "silkycream",
            "juicyfilets",
            "puremeat",
            "meatypate",
            "vet",
            "limited", 
        ]
    },
    sorts: {
        tags: [
            "huhn",
            "pute",
            "kanguru",
            "lachs",
            "thunfisch",
            "ente",
            "rind"
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-katzen-ubergewicht", {
    "feed-type": {
        tags: [
            "nassfutter",
            "trockenfutter",
            "snacks"
        ]
    },
    line: {
        tags: [
            "saucen-menu",
            "pasteten",
            "mousse",
            "filet-menu",
            "silkycream",
            "juicyfilets",
            "puremeat",
            "meatypate",
            "vet",
            "limited", 
        ]
    },
    sorts: {
        tags: [
            "huhn",
            "pute",
            "lachs",
            "thunfisch",
            "ente",
            "rind"
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-katzen-sterilisiert", {
    "feed-type": {
        tags: [
            "nassfutter",
            "trockenfutter",
            "snacks"
        ]
    },
    line: {
        tags: [
            "saucen-menu",
            "pasteten",
            "mousse",
            "filet-menu",
            "silkycream",
            "juicyfilets",
            "puremeat",
            "meatypate",
            "vet",
            "limited", 
        ]
    },
    sorts: {
        tags: [
            "huhn",
            "pute",
            "rind",
            "thunfisch"
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-katzen-freiganger", {
    "feed-type": {
        tags: [
            "nassfutter",
            "trockenfutter",
            "snacks"
        ]
    },
    line: {
        tags: [
            "saucen-menu",
            "pasteten",
            "mousse",
            "filet-menu",
            "silkycream",
            "juicyfilets",
            "puremeat",
            "meatypate",
            "vet",
            "limited", 
        ]
    },
    sorts: {
        tags: [
            "lachs",
            "huhn",
            "rind",
            "wild",
            "ente",
            "geflugel"
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-katzen-kitten-und-junge-katze", {
    "feed-type": {
        tags: [
            "nassfutter",
            "trockenfutter",
            "snacks"
        ]
    },
    line: {
        tags: [
            "saucen-menu",
            "pasteten",
            "mousse",
            "filet-menu",
            "silkycream",
            "juicyfilets",
            "puremeat",
            "meatypate",
            "vet",
            "limited", 
        ]
    },
    sorts: {
        tags: [
            "lachs",
            "huhn",
            "rind",
            "pute",
            "kalb"
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-katzen-senior", {
    "feed-type": {
        tags: [
            "nassfutter",
            "trockenfutter",
            "snacks"
        ]
    },
    line: {
        tags: [
            "saucen-menu",
            "pasteten",
            "mousse",
            "filet-menu",
            "silkycream",
            "juicyfilets",
            "puremeat",
            "meatypate",
            "vet",
            "limited", 
        ]
    },
    sorts: {
        tags: [
            "pute",
            "ente",
            "huhn",
            "kanguru",
            "rind",
            "truthahn",
            "lachs",
            "thunfisch",
            "kalb", 
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-katzen-senior-lp", {
    "feed-type": {
        tags: [
            "nassfutter",
            "trockenfutter",
            "snacks"
        ]
    },
    line: {
        tags: [
            "saucen-menu",
            "pasteten",
            "mousse",
            "filet-menu"
        ]
    },
    sorts: {
        tags: [
            "pute",
            "ente",
            "huhn",
            "kanguru",
            "rind",
            "truthahn",
            "lachs",
            "thunfisch",
            "kalb", 
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "tawkr-assortment", {
    species: {
        tags: [
            "fur-hunde",
            "fur-katzen"
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-hunde-und-katzen-nassfutter", {
    species: {
        tags: [
            "fur-hunde",
            "fur-katzen"
        ]
    },
    sorts: {
        tags: [
            "huhn",
            "rind",
            "ente",
            "pute",
            "kalb",
            "wild",
            "lachs",
            "pferd",
            "lamm",
            "vegan",
            "ziege",
            "hirsch",
            "kanguru",
            "kaninchen",
            "thunfisch", 
        ]
    },
    desires: {
        tags: [
            "getreidefrei",
            "glutenfrei",
            "hypoallergen",
            "monoprotein",
            "low-energy",
            "high-energy", 
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-hunde-und-katzen-trockenfutter", {
    species: {
        tags: [
            "fur-hunde",
            "fur-katzen"
        ]
    },
    sorts: {
        tags: [
            "huhn",
            "rind",
            "ente",
            "pute",
            "kalb",
            "wild",
            "lachs",
            "pferd",
            "lamm",
            "vegan",
            "ziege",
            "hirsch",
            "kanguru",
            "kaninchen",
            "thunfisch", 
        ]
    },
    desires: {
        tags: [
            "getreidefrei",
            "glutenfrei",
            "hypoallergen",
            "monoprotein",
            "low-energy",
            "high-energy", 
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-hunde-senior", {
    "feed-type": {
        tags: [
            "nassfutter",
            "trockenfutter",
            "barf",
            "snacks"
        ]
    },
    sorts: {
        tags: [
            "geflugel",
            "rind-and-kalb",
            "wild",
            "fisch",
            "lamm",
            "pferd",
            "kanguru",
            "kaninchen",
            "straus",
            "insekten",
            "vegetarisch-vegan",
            "schwein", 
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-hunde-probierpakete", {
    sorts: {
        tags: [
            "geflugel",
            "rind-and-kalb",
            "wild",
            "fisch",
            "lamm",
            "pferd",
            "ziege",
            "kanguru",
            "kaninchen",
            "straus",
            "schwein",
            "insekten",
            "vegetarisch-vegan", 
        ]
    },
    "nutritional-needs": {
        tags: [
            "sehr-wahlerisch",
            "verdauungsprobleme",
            "unvertraglichkeiten-allergien",
            "haut-and-fellprobleme",
            "bestimmte-erkrankung", 
        ],
        compare: "AND"
    },
    age: {
        tags: [
            "welpe",
            "adult-1-6-jahre",
            "senior-7-jahre"
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-hunde-adult", {
    sorts: {
        tags: [
            "geflugel",
            "rind-and-kalb",
            "wild",
            "fisch",
            "lamm",
            "pferd",
            "ziege",
            "kanguru",
            "wasserbuffel",
            "insekten",
            "vegetarisch-vegan", 
        ]
    },
    "hero-filter": {
        tags: [
            "nassfutter",
            "trockenfutter",
            "barf",
            "snacks"
        ]
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-hunde-alle-produkte", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, ALL_AVAILABLE_FILTERS)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "fur-katzen-alle-produkte", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, ALL_AVAILABLE_FILTERS)), _obj);
/* harmony default export */ __webpack_exports__["Z"] = (FILTER_CONFIG);


/***/ }),

/***/ 57359:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_segmentation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6813);
/* harmony import */ var modules_collection_state_filter_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31859);


/**
 * Get all available filters based on pet type
 */ var getAllFilter = function(param) {
    var petType = param.petType, _excludeKeys = param.excludeKeys, excludeKeys = _excludeKeys === void 0 ? [] : _excludeKeys;
    var allFilter = JSON.parse(JSON.stringify(modules_collection_state_filter_config__WEBPACK_IMPORTED_MODULE_1__/* .ALL_AVAILABLE_FILTERS */ .k));
    var filter = Object.entries(constants_segmentation__WEBPACK_IMPORTED_MODULE_0__/* .SEGMENTS_SLUGIFIED_FILTER_MAP */ .Gx).filter(function(entry) {
        if (petType === "cat") {
            if (!Array.isArray(entry[1])) {
                return (0,constants_segmentation__WEBPACK_IMPORTED_MODULE_0__/* .isCatSegmentation */ .no)(entry[1]);
            }
        } else if (petType === "dog") {
            if (Array.isArray(entry[1])) {
                return !!entry[1].find(function(v) {
                    return !(0,constants_segmentation__WEBPACK_IMPORTED_MODULE_0__/* .isCatSegmentation */ .no)(v);
                });
            }
            return !(0,constants_segmentation__WEBPACK_IMPORTED_MODULE_0__/* .isCatSegmentation */ .no)(entry[1]);
        }
    }).map(function(v) {
        return v[0];
    });
    var filteredAllFilter = Object.keys(allFilter).filter(function(key) {
        return !excludeKeys.includes(key);
    }).reduce(function(obj, key) {
        obj[key] = allFilter[key];
        return obj;
    }, {});
    if (!excludeKeys.includes("nutritional-needs")) {
        var ref, ref1;
        filteredAllFilter["nutritional-needs"] = {
            tags: ((ref = allFilter["nutritional-needs"]) === null || ref === void 0 ? void 0 : ref.tags.filter(function(v) {
                return filter.indexOf(v) > -1;
            })) || [],
            compare: (ref1 = allFilter["nutritional-needs"]) === null || ref1 === void 0 ? void 0 : ref1.compare
        };
    }
    return filteredAllFilter;
};
/* harmony default export */ __webpack_exports__["Z"] = (getAllFilter);


/***/ }),

/***/ 71033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ik": function() { return /* binding */ CdpType; },
/* harmony export */   "oR": function() { return /* binding */ modifyConfig; }
/* harmony export */ });
/* unused harmony export FilterOrderMapper */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67573);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69779);
/* harmony import */ var constants_segmentation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6813);
/* harmony import */ var interfaces_api_input_input_product_type__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67659);
/* harmony import */ var models_collection_constants_cat_general_cdp__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36602);
/* harmony import */ var models_collection_constants_dog_general_cdp__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75611);
/* harmony import */ var modules_collection_state_filter_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31859);
/* harmony import */ var utils_api_smartCollection__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64544);









var CdpType = {
    BreedCdp: "0",
    NeedCdp: "1",
    AgeTypeCdp: "2",
    FoodTypeCdp: "3",
    Home: "4",
    YourPetProfile: "5"
};
/**
 * Create a map which is mapped with CDP type
 * key : handle / special cdp type (home / your pet profile)
 * Value : CDP type
 */ var CdpTypeMapper = new Map();
/**
 * Check if the collection is snack collection
 */ var isSnackCdp = function(handle) {
    return utils_api_smartCollection__WEBPACK_IMPORTED_MODULE_5__/* .CDP_MAPPING.filter */ .u2.filter(function(config) {
        return config.productType === interfaces_api_input_input_product_type__WEBPACK_IMPORTED_MODULE_1__/* .InputProductType.Snacks */ .G.Snacks;
    }).some(function(config) {
        return config.url.some(function(url) {
            return url.replace(/^\/collections\//, "") === handle;
        });
    });
};
var getKeyBySegmentationId = function(param) {
    var segmentation = param.segmentation;
    if ((0,constants_segmentation__WEBPACK_IMPORTED_MODULE_0__/* .isBreedSegmentation */ .dd)(segmentation)) {
        return CdpType.BreedCdp;
    } else if ((0,constants_segmentation__WEBPACK_IMPORTED_MODULE_0__/* .isAgeSegmentation */ .lr)(segmentation)) {
        return CdpType.AgeTypeCdp;
    } else if ((0,constants_segmentation__WEBPACK_IMPORTED_MODULE_0__/* .isNutritionSegmentation */ .i_)(segmentation)) {
        return CdpType.NeedCdp;
    }
};
/** set segmentation related cdp */ constants_segmentation__WEBPACK_IMPORTED_MODULE_0__/* .SegmentationData.segmentation.map */ .ck.segmentation.map(function(segment) {
    var cdpTypeKey = getKeyBySegmentationId({
        segmentation: segment.id
    });
    if (cdpTypeKey) {
        segment.redirectPages.forEach(function(url) {
            var handle = url.replace(/^\/collections\//, "");
            CdpTypeMapper.set(handle, cdpTypeKey);
        });
    }
});
/** set general cdp */ utils_api_smartCollection__WEBPACK_IMPORTED_MODULE_5__/* .CDP_MAPPING.map */ .u2.map(function(v) {
    return v.url;
}).forEach(function(urls) {
    urls.forEach(function(url) {
        var handle = url.replace(/^\/collections\//, "");
        CdpTypeMapper.set(handle, CdpType.FoodTypeCdp);
    });
});
var SPECIAL_HANDLE = [
    CdpType.Home,
    CdpType.YourPetProfile
];
SPECIAL_HANDLE.forEach(function(cdpType) {
    CdpTypeMapper.set(cdpType, cdpType);
});
var _obj;
/**
 * Mapper for CDP type and filter combination and it's order.
 * @see https://docs.google.com/spreadsheets/d/1cE3zs5OLUE1jgvy1AXcALUTJjzJblWJ72IW3MGuiC6s/edit?pli=1&gid=1714492367#gid=1714492367
 */ var FilterOrderMapper = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, CdpType.BreedCdp, [
    "feed-type",
    "sorts",
    "desires"
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, CdpType.NeedCdp, [
    "feed-type",
    "sorts",
    "desires"
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, CdpType.AgeTypeCdp, [
    "feed-type",
    "sorts",
    "desires"
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, CdpType.FoodTypeCdp, [
    // General
    [
        "nutritional-needs",
        "age",
        "sorts",
        "desires",
        "sizes"
    ],
    // When pet profile is active
    [
        "sorts",
        "desires",
        "sizes"
    ], 
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, CdpType.Home, [
    "nutritional-needs",
    "age",
    "feed-type",
    "sorts"
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, CdpType.YourPetProfile, [
    "sorts",
    "desires"
]), _obj);
var getFilterOrder = function(param) {
    var isPetProfileApplied = param.isPetProfileApplied, handle = param.handle;
    var cdpType = CdpTypeMapper.get(handle);
    if (!cdpType) {
        // If the CDP type is not found, return the default filter config
        var baseConfig = modules_collection_state_filter_config__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z[handle];
        return baseConfig ? Object.keys(baseConfig) : undefined;
    }
    var filters = FilterOrderMapper[cdpType];
    // Add snack-type filter for snack collections
    if (isSnackCdp(handle)) {
        if (Array.isArray(filters[0])) {
            filters = filters.map(function(filterSet) {
                return [
                    "snack-type"
                ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(filterSet));
            });
        } else {
            filters = [
                "snack-type"
            ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(filters));
        }
    }
    if (filters.some(function(v) {
        return Array.isArray(v);
    }) && typeof isPetProfileApplied === "boolean") {
        var index = isPetProfileApplied ? 1 : 0;
        return filters[index];
    }
    return filters;
};
var reorderObject = function(obj, keysOrder) {
    if (!Array.isArray(keysOrder)) return obj;
    var reorderedObj = {};
    keysOrder.forEach(function(key) {
        if (key in obj) {
            reorderedObj[key] = obj[key];
        }
    });
    return reorderedObj;
};
/**
 * Modify config order by definitions
 */ var modifyConfig = function(param) {
    var filterConfig = param.filterConfig, handle = param.handle, isPetProfileApplied = param.isPetProfileApplied;
    var filterOrder = getFilterOrder({
        handle: handle,
        isPetProfileApplied: isPetProfileApplied
    });
    if (!filterOrder) {
        return filterConfig;
    }
    // Ensure we have a flat array to work with
    var reorderConfig = Array.isArray(filterOrder) ? Array.isArray(filterOrder[0]) ? (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(filterOrder[0]) : (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(filterOrder) : [];
    var temp = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, filterConfig);
    // Special case for Cat All Feed Types Collection
    if (handle === models_collection_constants_cat_general_cdp__WEBPACK_IMPORTED_MODULE_2__/* .CatGeneralCdpHandle.CatAllFeedTypesHandle */ .Q.CatAllFeedTypesHandle) {
        var catAllFeedTypesFilters = modules_collection_state_filter_config__WEBPACK_IMPORTED_MODULE_4__/* ["default"]["fur-katzen-alle-fleischsorten"] */ .Z["fur-katzen-alle-fleischsorten"];
        if (catAllFeedTypesFilters === null || catAllFeedTypesFilters === void 0 ? void 0 : catAllFeedTypesFilters["hero-filter"]) {
            reorderConfig = [
                "hero-filter"
            ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(reorderConfig));
            temp.line = catAllFeedTypesFilters["hero-filter"];
            // Remove feed-type filter since it'd be redundant
            if (temp["feed-type"]) delete temp["feed-type"];
        }
    }
    // Required for marketing usage
    if (handle === models_collection_constants_cat_general_cdp__WEBPACK_IMPORTED_MODULE_2__/* .CatGeneralCdpHandle.CatWetFoodHandle */ .Q.CatWetFoodHandle) {
        var catWetFoodFilters = modules_collection_state_filter_config__WEBPACK_IMPORTED_MODULE_4__/* ["default"]["fur-katzen-nassfutter"] */ .Z["fur-katzen-nassfutter"];
        if (catWetFoodFilters === null || catWetFoodFilters === void 0 ? void 0 : catWetFoodFilters.line) {
            reorderConfig = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(reorderConfig.slice(0, 1)).concat([
                "line", 
            ], (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(reorderConfig.slice(1)));
            temp.line = catWetFoodFilters.line;
        }
    }
    if (handle === models_collection_constants_dog_general_cdp__WEBPACK_IMPORTED_MODULE_3__/* .DogGeneralCdpHandle.DogDryFoodHandle */ .l.DogDryFoodHandle) {
        var dogDryFoodFilters = modules_collection_state_filter_config__WEBPACK_IMPORTED_MODULE_4__/* ["default"]["fur-hunde-trockenfutter"] */ .Z["fur-hunde-trockenfutter"];
        if (dogDryFoodFilters === null || dogDryFoodFilters === void 0 ? void 0 : dogDryFoodFilters.line) {
            reorderConfig = [
                "line"
            ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(reorderConfig));
            temp.line = dogDryFoodFilters.line;
        }
    }
    return reorderObject(temp, reorderConfig);
};


/***/ }),

/***/ 64544:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fn": function() { return /* binding */ generateInputFromSegmentationIds; },
/* harmony export */   "HC": function() { return /* binding */ isGenericCdpPage; },
/* harmony export */   "VF": function() { return /* binding */ generateInputFromSegmentation; },
/* harmony export */   "XX": function() { return /* binding */ generateInputFromPetProfile; },
/* harmony export */   "tC": function() { return /* binding */ generateInputFromCdpPath; },
/* harmony export */   "u2": function() { return /* binding */ CDP_MAPPING; },
/* harmony export */   "zg": function() { return /* binding */ mergeDynamicInput; }
/* harmony export */ });
/* unused harmony exports getProductTypeFromCDPUrl, retrieveSegmentationByPetType */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80969);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69779);
/* harmony import */ var constants_segmentation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6813);
/* harmony import */ var interfaces_api_input_input_product_type__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67659);
/* harmony import */ var utils_type_helper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79221);






var CDP_MAPPING = [
    {
        url: [
            "/collections/fur-hunde-nassfutter"
        ],
        productType: interfaces_api_input_input_product_type__WEBPACK_IMPORTED_MODULE_1__/* .InputProductType.WetFood */ .G.WetFood
    },
    {
        url: [
            "/collections/fur-hunde-trockenfutter"
        ],
        productType: interfaces_api_input_input_product_type__WEBPACK_IMPORTED_MODULE_1__/* .InputProductType.DryFood */ .G.DryFood
    },
    {
        url: [
            "/collections/fur-hunde-barf-frische-menus"
        ],
        productType: interfaces_api_input_input_product_type__WEBPACK_IMPORTED_MODULE_1__/* .InputProductType.Barf */ .G.Barf
    },
    {
        url: [
            "/collections/fur-hunde-snacks"
        ],
        productType: interfaces_api_input_input_product_type__WEBPACK_IMPORTED_MODULE_1__/* .InputProductType.Snacks */ .G.Snacks
    },
    {
        url: [
            "/collections/fur-katzen-nassfutter"
        ],
        productType: interfaces_api_input_input_product_type__WEBPACK_IMPORTED_MODULE_1__/* .InputProductType.WetFood */ .G.WetFood
    },
    {
        url: [
            "/collections/fur-katzen-trockenfutter"
        ],
        productType: interfaces_api_input_input_product_type__WEBPACK_IMPORTED_MODULE_1__/* .InputProductType.DryFood */ .G.DryFood
    },
    {
        url: [
            "/collections/fur-katzen-barf-frische-menus"
        ],
        productType: interfaces_api_input_input_product_type__WEBPACK_IMPORTED_MODULE_1__/* .InputProductType.Barf */ .G.Barf
    },
    {
        url: [
            "/collections/fur-katzen-snacks"
        ],
        productType: interfaces_api_input_input_product_type__WEBPACK_IMPORTED_MODULE_1__/* .InputProductType.Snacks */ .G.Snacks
    }, 
];
var getProductTypeFromCDPUrl = function(param) {
    var url = param.url;
    var trimmedUrl = url.replace(/\/collections\/[^\/]+\/.*$/, "");
    return CDP_MAPPING.find(// It needs to remove the filters in the url, in case these are present
    function(seg) {
        return seg.url.some(function(redirectPage) {
            return redirectPage === trimmedUrl;
        });
    });
};
/**
 * Check if cdp is a generic cdp (e.g wet food, dry food )
 */ var isGenericCdpPage = function(param) {
    var url = param.url;
    return !!getProductTypeFromCDPUrl({
        url: url
    });
};
var processSegmentation = function(seg) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, (0,constants_segmentation__WEBPACK_IMPORTED_MODULE_0__/* .isBreedSegmentation */ .dd)(seg) && {
        breed: seg
    }, (0,constants_segmentation__WEBPACK_IMPORTED_MODULE_0__/* .isAgeSegmentation */ .lr)(seg) && {
        age: seg
    }, (0,constants_segmentation__WEBPACK_IMPORTED_MODULE_0__/* .isNutritionSegmentation */ .i_)(seg) && {
        needs: [
            seg
        ]
    }, (0,constants_segmentation__WEBPACK_IMPORTED_MODULE_0__/* .isAllergySegmentation */ .Hz)(seg) && {
        allergies: [
            seg
        ]
    });
};
/**
 * Generate api input from petProfile type
 */ var generateInputFromPetProfile = function(param) {
    var petProfile = param.petProfile, _omitFoodType = param.omitFoodType, omitFoodType = _omitFoodType === void 0 ? false : _omitFoodType;
    var input = generateInputFromSegmentation({
        segmentation: {
            breedSegmentation: petProfile.selectedBreed,
            needSegmentation: petProfile.selectedNeeds,
            ageSegmentation: petProfile.selectedAge,
            allergySegmentation: petProfile.selectedAllergies
        }
    });
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, input, omitFoodType ? {} : {
        food_types: petProfile.selectedFoodTypes
    });
};
var keysToOmit = [
    "lastSegmentation"
];
/**
 * Generate api input from segmentation (single or multiple)
 */ var generateInputFromSegmentation = function(param) {
    var segmentation = param.segmentation;
    if (typeof segmentation === "string") {
        return processSegmentation(segmentation);
    }
    var values = Object.entries(segmentation).map(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
        if (!keysToOmit.includes(key)) {
            return value;
        }
    }).flat().filter(utils_type_helper__WEBPACK_IMPORTED_MODULE_4__/* .omitNullableHandler */ .vc).sort();
    var apiInput = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            var processed = processSegmentation(value);
            apiInput = mergeDynamicInput({
                target: apiInput,
                source: processed
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return apiInput;
};
/**
 * Remove unrelated segmentation ids from store based on pet type
 */ var retrieveSegmentationByPetType = function(param) {
    var segmentation = param.segmentation, currentPetType = param.currentPetType;
    if (!currentPetType) {
        return segmentation;
    }
    var output = {};
    Object.entries(segmentation).forEach(function(entry) {
        var value;
        if (Array.isArray(entry[1])) {
            value = entry[1].filter(function(v) {
                if (isCatSegmentation(v)) {
                    return currentPetType === "cats";
                } else {
                    return currentPetType === "dogs";
                }
            });
        } else {
            if (isCatSegmentation(entry[1])) {
                if (currentPetType === "cats") {
                    value = entry[1];
                }
            } else {
                if (currentPetType === "dogs") {
                    value = entry[1];
                }
            }
        }
        output[entry[0]] = value;
    });
    return output;
};
/**
 * Helper function to generate input from array of segmentationIds
 */ var generateInputFromSegmentationIds = function(param) {
    var segmentationIds = param.segmentationIds;
    var apiInput = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = segmentationIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            var processed = processSegmentation(value);
            apiInput = mergeDynamicInput({
                target: apiInput,
                source: processed
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return apiInput;
};
var mergeDynamicInput = function(param) {
    var source = param.source, target = param.target;
    // Merge arrays rather than overwrite
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, source, Object.keys(target).reduce(function(acc, key) {
        var existingValue = source[key];
        var newValue = target[key];
        if (Array.isArray(existingValue) && Array.isArray(newValue)) {
            // If both are arrays, concatenate them
            acc[key] = Array.from(new Set((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(existingValue).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(newValue))));
        } else if (newValue !== undefined) {
            // Otherwise, just assign the new value
            acc[key] = newValue;
        }
        return acc;
    }, {}));
};
/**
 * Helper function to generate SmartCollectionInput from segmentation
 * @TODO : age mapping and allergy mapping
 */ var generateInputFromCdpPath = function(param) {
    var path = param.path;
    var segmentation = (0,constants_segmentation__WEBPACK_IMPORTED_MODULE_0__/* .getSegmentationFromUrl */ .x9)({
        url: path
    });
    if (segmentation) {
        var id = segmentation.id;
        return processSegmentation(id);
    }
    var config = getProductTypeFromCDPUrl({
        url: path
    });
    if (config) {
        return {
            food_types: [
                config.productType
            ]
        };
    }
};


/***/ })

}]);